import React, { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import AboutJoseph from "../components/AboutJoseph";
import Services from "../components/Services";
import QuoteCalculator from "../components/QuoteCalculator";
import RequestForm from "../components/BookingForm";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import { SERVICE_TOWNS } from "../lib/towns";

export default function Home() {
  const [quoteState, setQuoteState] = useState({
    singleOut: 8,
    inside: 8,
    secondOut: 0,
    town: SERVICE_TOWNS[0], // San Angelo
    manualMiles: "",
  });

  return (
    <div className="min-h-screen bg-[#F9F9F6] text-[#111827] antialiased">
      <Header />
      <main>
        <Hero />
        <AboutJoseph />
        <Services />
        <QuoteCalculator value={quoteState} onChange={setQuoteState} />
        <RequestForm quoteState={quoteState} />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
}
